import React from "react";
import { Link } from "react-router-dom";
import "./../../styles/home-sections/CustomSection.css";
import "./../../styles/NeonButton.css";

// Importa las imágenes
import locationIcon from "../../assets/location-icon.png";
import mapIcon from "../../assets/path-icon.png";
import supportIcon from "../../assets/meeting-icon.png";

const StatisticsSection = () => {
  return (
    <section className="custom-section section-container">
      <div className="custom-section-left">
        <h1 className="section-title">
          Apoyamos a mujeres que han superado el cáncer de mama a través del
          Camino de Santiago
        </h1>
        <p className="section-text">
          La actual Asociación surge como iniciativa de profesionales y amigos
          del Hospital de Valme en 2016, con el objetivo de promover el
          ejercicio, el apoyo mutuo y la superación personal para mujeres que
          han superado el cáncer de mama, recorriendo el Camino de Santiago y
          realizando las "Rutas Rosas" de entrenamiento.
        </p>
        <Link to="/asociacion" className="neon-button button-left">
          Descubre nuestra Asociación
        </Link>
      </div>
      <div className="custom-section-right section-statistics stats-container">
        <div className="stat-item">
          <div className="stat-header">
            <h2 className="stat-title">
              <img src={locationIcon} alt="Ubicación" className="stat-icon" />
            </h2>
          </div>
          <p className="stat-text">
            <strong>50+ ciudades y pueblos</strong> visitados a través de
            nuestras rutas
          </p>
        </div>
        <div className="stat-item">
          <div className="stat-header">
            <h2 className="stat-title">
              <img src={mapIcon} alt="Mapa" className="stat-icon" />
            </h2>
          </div>
          <p className="stat-text">
            <strong>1,000+ kilómetros</strong> recorridos en distintas partes de
            la península
          </p>
        </div>
        <div className="stat-item">
          <div className="stat-header">
            <h2 className="stat-title">
              <img src={supportIcon} alt="Apoyo" className="stat-icon" />
            </h2>
          </div>
          <p className="stat-text">
            <strong>Reuniones, charlas y coloquios</strong> ofrecidos
            y con participación de los asociados
          </p>
        </div>
      </div>
    </section>
  );
};

export default StatisticsSection;
